import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import {
  FD_TICKET,
  CREATE_FD_RESULT,
  GET_VIEW_FD
} from './type';

export const fetchfdTicketList = (filterData = null, page = 1) => async (
  dispatch
) => {
  dispatch({
    type: FD_TICKET,
    payload: null,
  });
  let filterQuery = '';
  if (filterData !== null) {
    filterQuery = `?page=${page}`;
    if (filterData?.status) {
      filterQuery = filterQuery + `&status=${filterData.status}`;
    }
    if (filterData?.freshdesk_id) {
      filterQuery = filterQuery + `&freshdesk_id=${filterData.freshdesk_id}`;
    }
    if (filterData?.priority) {
      filterQuery = filterQuery + `&priority=${filterData.priority}`;
    }
  } else {
    filterQuery = `?page=${page}`;
  }
  // console.log(filterData)
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.fileComplain.listFdTickets}${filterQuery}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: FD_TICKET,
      payload: data.response.data,
    });
    return true;
  }
};

export const saveFdTicket = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.fileComplain.createFdTickets
  );
  /* if (res) {
    const { data } = res;
    dispatch({ type: REOPEN_COMPLAIN, payload: data.response.data });
    return true;
  } */
  if (res?.data?.response?.status === true) {
    return true;
  } else {
    return false;
  }
};

export const viewDetails = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.fileComplain.viewFdTicketDetails}?id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_VIEW_FD, payload: data.response.data });
    return true;
  }
};